export default {
    "search": {
        "emptySearchNotification": "Veuillez saisir des termes de recherche pour effectuer une recherche",
        "alreadySelected": "Déjà sélectionné"
    },

    "breadcrumbs": {
        "emptySearch": "<recherche vide>",
        "itemRemove": "Supprimer"
    },

    "didYouMean": {
        "dymonlyBeforeCorrected": "Essayez avec cette orthographe : ",
        "dymonlyAfterCorrected": "",
        "correctBeforeCorrected": "Résultats pour : ",
        "correctBeforeOriginal": ". Essayez avec l'orthographe : ",
        "correctAfterOriginal": "",
        "smartBeforeOriginal": "Résultats pour : ",
        "smartBeforeCorrected": " et ",
        "smartAfterCorrected": ""
    },

    "pageSizeSelector": {
        "pageSizeChoice": "{size, number} par page",
        "defaultPageSize": "Défaut ({size, number})",
        "defaultPageSizeChoice": "{size, number} par page (défaut)"
    },

    "pager": {
        "pageNumberTitle": "Page {page, number}",
        "firstPage": "Première page",
        "nextPage": "Page suivante",
        "previousPage": "Page précédente",
        "lastPage": "Dernière page"
    },

    "sortSelector": {
        "sortByTitle": "Trier par: {text}",
        "sortOther": "<Autre>"
    },

    "sort": {
        "relevance": "Pertinence",
        "date": "Date",
        "filename": "Nom de fichier",
        "title": "Titre"
    },

    "queryIntent": {
        "externalServiceTimeoutError": "Cette page de résultat est incomplète due à un délai d'attente interne dépassé. S'il vous plaît, réessayez plus tard."
    },

    "scopes": {
        "allScopes": "Toutes les sources"
    }
};
